/** Texto del contador de avisos sin leer (menú y campana); null = no se muestra. */
export function unreadBadge(n: number): string | null {
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return n > 99 ? '99+' : String(Math.trunc(n));
}

/** Texto del contador cuando no se pudo consultar (menú y campana, UX-ERR-01). */
export const UNREAD_UNKNOWN = 'No se pudo consultar cuántos avisos hay sin leer';
